<!-- 卸车数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="150px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row v-if="dataActionBox.actionType != 2">
                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                        <df-date :isdisabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                        <!-- 采购订单id(多个逗号拼接) -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'psomId'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input  @focus="openSearch(formOneValue.searchId, 'psomId')" :disabled="formOneValue.isChange == 0" clearable v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                          <el-button @click="openSearch(formOneValue.searchId, 'psomId')" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
</el-tooltip>
                        <!-- 车牌号 -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'vmLicensecode'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
        <el-input v-if="formOneValue.fieldType == 'search'" @focus="openSearch(formOneValue.searchId, 'vmLicensecode')" :disabled="formOneValue.isChange == 0" clearable v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                        <el-button @click="openSearch(formOneValue.searchId, 'vmLicensecode')" slot="append" icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <el-input v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                    </el-input>
</el-tooltip>
                        <!-- 司机名称 -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'driverName'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''? true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
        <el-input v-if="formOneValue.fieldType == 'search'" @focus="openSearch(formOneValue.searchId, 'driverName')" :disabled="formOneValue.isChange == 0" clearable v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                        <el-button @click="openSearch(formOneValue.searchId,'driverName')" slot="append" icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <el-input v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                    </el-input>
</el-tooltip>
                        <!-- 卸车费用 -->
                        <el-input v-else-if="formOneValue.entityField == 'unloadMoney'" :maxlength="$store.state.inputLength" type="number" v-model.number="sendDataInfo[formOneValue.entityField]" min="0" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                        <el-input v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                        </el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                              <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                 <span v-if="formOneValue.isRift == 1">
                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                          sendDataInfo[formOneValue.entityField] }}</a>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'date'">
                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                       {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                 </span>
                                 <span v-else-if="formOneValue.fieldType == 'formatter'">
                                    {{ $common.getIsGsp(formOneValue.formatterContent, sendDataInfo[formOneValue.entityField]) }}
                                 </span>
                                 <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{ sendDataInfo[formOneValue.entityField]
                          == 1 ? "是" : "否" }}</span>
                                 <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                  </el-form>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div class="foots">
          <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">
            取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>

      </div>
    </div>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 订单提取 -->
    <el-dialog v-if="unLoadingRecordVisible" :visible.sync="unLoadingRecordVisible" title="提取采购订单" width="96%" :modal-append-to-body='true' :append-to-body="true">
      <unLoadingRecordListAction :pageShowData="childPageShowData" @loadingRecordReturn="loadingRecordReturn">
      </unLoadingRecordListAction>
    </el-dialog>
    <el-dialog title="采购订单列表" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchSchemeordeunloading ref="invoiceExtract" :parentType="true" @invoiceExtractMethods="getExData" />
      <!-- <SearchSchemeordeunloading ref="SearchSchemeordeunloading" :id="searchId" :parentSearchData="parentSearchData1" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="getSelect">确认选择</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import SearchSchemeordeunloading from "../byComponents/SearchSchemeordeunloading.vue";
export default {
  name: 'unloadingListRecordAction',
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    SearchSchemeordeunloading,
  },
  data() {
    //这里存放数据
    return {
      ids: [],
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        driverName: "",
        unloadMoney: 0,
        unloader: "",
        vmLicensecode: "",
        ids: []
      },
      showTabs: "",
      formDataList: [],
      DialogVisible: false, //检索信息
      seId: "",
      seWidth: "",
      seTitle: "",
      searchType: "",
      parentSearchData: {
        opmDriver: 0,
        opmBuyer: 1,
      },
      childPageShowData: [], //子组件的表格头
      unLoadingRecordVisible: false,
      isLoaded: false,
      mainData: [],
      DialogVisible1: false,
      searchId: "",
      parentSearchData1: {
        cmId: "",
        coId: "",
        opmId: "",
        salesId: "",
        depId: "",
      },
      detailSelectList: [],
      selectedDataIndex: 0,
      mxHeight: 400
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async extract(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.DialogVisible1 = true;
        }
      });
    },
    async getExData(res) {
      this.sendDataInfo.unloadDetailList = [];
      let val = JSON.parse(JSON.stringify(res));
      console.log("提取", val);
      this.mainData = val.mainData;
      this.detailData = val.detailData;
      this.DialogVisible1 = false;
    },
    //卸车单据子组件
    loadingRecordReturn(str) {
      this.sendDataInfo.psomId = str;
      this.unLoadingRecordVisible = false;
    },

    //提取返回
    changeInputModel(val) {
      console.log("返回", val);
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.searchType == "driverName") {
          //司机
          this.sendDataInfo.driverName = val.opmName;
        } else if (this.searchType == "vmLicensecode") {
          //车
          this.sendDataInfo.vmLicensecode = val.vmLicensecode;
        }
      } else {
        this.$message({
          message: "检索信息失败",
          type: "warning",
        });
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, type) {
      if (type != "psomId") {
        type == "driverName" ?
          (this.parentSearchData.opmDriver = 1) :
          (this.parentSearchData.opmDriver = "");
        type == "driverName" ?
          (this.parentSearchData.opmBuyer = "") :
          (this.parentSearchData.opmBuyer = 1);
        this.seId = sId;
        this.searchType = type;
        this.DialogVisible = true;
      } else {
        this.unLoadingRecordVisible = true;
      }
    },

    //确认新增
    sendDataAction(formName1) {
      this.sendDataInfo.ids = this.ids
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          this.$message({
            message: "请完善必填信息",
            type: "error",
          });
          return false;
        }
      });
    },
    async sub() {
      var responseData;
      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.unloadAdd(this.sendDataInfo);
      } else {
        // responseData = await this.$http.setTransportdocAdd(this.sendDataInfo)
      }
      if (responseData.status == 200) {
        this.init();
        this.$refs["sendDataInfo"].resetFields();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel");
        // this.dataActionBox.showStatus = false
        // this.$parent.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    //取消
    initActionBox(formName1) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
      this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel");
          this.init();
          this.$refs[formName1].resetFields();
        })
        .catch(() => { });
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "dewmuColdAdd") {
          this.sendDataInfo[key] = this.$moment().valueOf();
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    //父级传入
    openBox(cate, formData, oldData = "") {
      this.showTabs = formData[0].jciName;
      this.formDataList = formData;
      this.ids = oldData?.map(item => {
        return item.psrgmId
      })
      this.init();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.$set(this.sendDataInfo, key, dataInfo[key])
        }
      }
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
      this.childPageShowData = [formData[2], formData[1]]; //子组件的表格头
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData;
      this.openBox(params[0], params[1], params[2]);
      this.isLoaded = true;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}
</style>
